/* eslint-disable complexity */
import React, { Component } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';

import { Timezone } from '@scale/shared/defaults';
// TODO: Migrate module so that you don’t import from the dashboard project in a global module
// eslint-disable-next-line restrict-imports/restrict-imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const DATE_FORMAT = 'MM-dd hh:mm';

type Props = {
  onToggleTimezoneModal?: () => void;
  onChange: (to: moment.Moment) => void;
  timezone?: Timezone;
  className?: string;
  small?: boolean;
  fromLabel?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  showTimeSelect?: boolean;
  minDate?: moment.Moment | null;
  maxDate?: moment.Moment | null;
  showTimezoneLabel?: boolean;
  selected?: moment.Moment | null;
};

export default class TimePicker extends Component<Props> {
  get fromLabel() {
    if (this.props.fromLabel) {
      return this.props.fromLabel;
    }

    return 'FROM';
  }

  renderCustomCSS() {
    const dateWidth = '65px';
    return (
      <style jsx global>{`
        .date-range-picker__label {
          justify-content: center;
          align-items: center;
          font-size: 12px;
          margin: auto 20px;
          text-transform: uppercase;
        }

        .react-datepicker-time__header {
          color: white;
        }

        .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
          color: white !important;
        }

        .date-range-picker__label:first-child {
          margin: auto 20px auto 0;
        }

        .date-range-picker__date {
          cursor: pointer;
          color: var(--color-form-input);
          padding: 10px 0;
          width: ${dateWidth};
          align-items: center;
          font-size: 13px;
          border-radius: 8px;
          background: transparent;
          border: 0;
          text-align: center;
          appearance: none;
          margin: 0;
        }

        .date-picker.small .date-range-picker__date {
          padding: 6px 0;
        }

        .date-range-picker__date:focus {
          border-color: #ccc;
          outline: 0;
        }

        .react-datepicker-popper {
          z-index: 1000;
        }

        .react-datepicker {
          box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
          border: 0;
          font-family: var(--font-family);
        }
        .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
          border-bottom-color: #222228;
        }
        .react-datepicker__header {
          background: #222228;
          border: 0;
        }

        .react-datepicker__header .react-datepicker__current-month {
          color: white;
        }
        .react-datepicker__header .react-datepicker__day-names {
          margin-top: 10px;
        }
        .react-datepicker__header .react-datepicker__day-name {
          color: white;
        }

        .react-datepicker__day--selected,
        .react-datepicker__day--in-selecting-range,
        .react-datepicker__day--in-range {
          background: #2773ff;
          background-color: #2773ff !important;
        }
      `}</style>
    );
  }

  render() {
    const { small, style, selected, onChange, className, timezone, onToggleTimezoneModal } =
      this.props;

    let timezoneLabel = 'UTC';
    if (timezone === Timezone.Pacific) {
      timezoneLabel = 'PST/PDT';
    } else if (timezone === Timezone.Local) {
      const timeOffset = new Date().getTimezoneOffset() / 60;
      let localGmt;
      if (timeOffset > 0) {
        localGmt = `-${timeOffset}`;
      } else if (timeOffset < 0) {
        localGmt = `+${Math.abs(timeOffset)}`;
      }
      timezoneLabel = `GMT${localGmt}`;
    }
    return (
      <div className={classnames('date-picker', { small }, className)} style={style}>
        <div className="date-range-picker__container">
          {/* <div className="date-range-picker__label">{this.fromLabel}</div> */}
          <FontAwesomeIcon
            icon="clock"
            style={{ margin: '0 6px 0 14px', color: 'var(--color-primary)' }}
          />
          <DatePicker
            dateFormat={DATE_FORMAT}
            selected={selected}
            onChange={onChange}
            className="date-range-picker__date"
            showTimeSelect
            timeIntervals={15}
            timeCaption="Time"
          />

          {this.props.showTimezoneLabel !== false ? (
            <span className="utc" onClick={onToggleTimezoneModal && onToggleTimezoneModal}>
              {timezoneLabel}
            </span>
          ) : (
            <div className="hsp__2" />
          )}
        </div>
        <style jsx>{`
          .date-picker.top-filters .date-range-picker__container {
            padding-left: 3px;
            height: 32px;
            border: 0;
            box-sizing: border-box;
          }

          .date-range-picker__container {
            align-items: center;
            display: flex;
            border-radius: 8px;
            background: var(--bg-form-input);
            padding-right: 6px;
          }

          .date-picker {
            display: flex;
            align-items: center;
          }

          .utc {
            color: #666;
            font-size: 12px;
            margin-right: 10px;
            letter-spacing: 0.3px;
          }
        `}</style>
      </div>
    );
  }
}
